export const isLocalhost = () =>
  import.meta.env.LH_TIMP_ENV_NAME === 'localhost'
